import styled from "styled-components";

export const UnitSelectorWrapper = styled.div`
  padding-left: ${(props) => (props.stepperEnabled ? "30px" : "0")} !important;
`;
